import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outsource-payments',
  templateUrl: './outsource-payments.component.html',
  styleUrls: ['./outsource-payments.component.scss']
})
export class OutsourcePaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
